import auth0 from './auth0';

export function signup(auth0) {
  return function execute() {
    auth0.authorize();
  };
}

export default signup(auth0);
